import { render } from "./HomepageCTA.vue?vue&type=template&id=16dbbc32&scoped=true"
const script = {}

import "./HomepageCTA.vue?vue&type=style&index=0&id=16dbbc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dbbc32"]])

export default __exports__